var app = angular.module('directives.cardPayBlock');
var template = require('../templates/index.html');

app.directive('authMasterpass', [
    'configs',
    '$translate',
    '$state',
    '$rootScope',
    'ClientCards',
    'Notification',
    '$translate',
    'Authentication',
    function(configs, $translate, $state, $rootScope, ClientCards, Notification, $translate, Authentication) {
        return {
            restrict: 'E',
            template: template,
            scope: {
              otp: '=',
              mpstatus: '=mpstatus',
              clear: '<'
          },
            controller:'authMasterpassCtrl'
        }
    }
]);

app.controller('authMasterpassCtrl',function ($scope, $state, $timeout, $rootScope, ClientCards, Notification, $translate, Authentication, Storage) {
    $scope.userPhoneMask = '';

    function init () {
        $scope.userPhoneMask = Authentication.user.phone.slice(-2);
    }

    $scope.validateSMS = function (code) {

        if(Storage.getItem('mp_status') == 'CONFIRMATION_NEEDED') {
            ClientCards.confirmMPWalletLinkOTP({code: code}).then(function (res) {
                if (res.status === 'success') {

                    ClientCards.data.mpStatus = res.mp_status;
                    Storage.setItem('mp_status', res.mp_status);

                    $translate('MYCARDS.MASTERPASS_AUTH_SUCCESS').then(function(message) {
                        Notification.success({
                            message: message,
                            delay: 5000
                        });
                    });

                    $rootScope.$broadcast('getList');
                }
            })
        } else {
            $rootScope.$broadcast('validateSMS', {code: code});
        }
    };
    init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/authMasterpass/directives/authMasterpass.js
 ** module id = 122
 ** module chunks = 1
 **/